import { render } from "./stock.one.dcb.vue?vue&type=template&id=5ff34e5a&scoped=true"
import script from "./stock.one.dcb.vue?vue&type=script&lang=js"
export * from "./stock.one.dcb.vue?vue&type=script&lang=js"

import "./stock.one.dcb.vue?vue&type=style&index=0&id=5ff34e5a&scoped=true&lang=css"

import exportComponent from "/drone/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ff34e5a"]])

export default __exports__